	var particleSystem = null;
	var stage = null;

	window.addEventListener("load", function () {
	  stage = new createjs.Stage("myCanvas");

	  particleSystem = new particlejs.ParticleSystem();

	  stage.addChild(particleSystem.container);

	  particleSystem.importFromJson(
{
	"bgColor": "#bfcbff",
	"width": 1980,
	"height": 180,
	"emitFrequency": 200,
	"startX": 981,
	"startXVariance": 1980,
	"startY": -59,
	"startYVariance": 75,
	"initialDirection": "0",
	"initialDirectionVariance": "360",
	"initialSpeed": "2",
	"initialSpeedVariance": "3.7",
	"friction": "0.038",
	"accelerationSpeed": 0.052,
	"accelerationDirection": 90,
	"startScale": 0.08,
	"startScaleVariance": 0.27,
	"finishScale": "0",
	"finishScaleVariance": "0",
	"lifeSpan": 141,
	"lifeSpanVariance": "196",
	"startAlpha": "1",
	"startAlphaVariance": "0",
	"finishAlpha": "0.35",
	"finishAlphaVariance": 0.5,
	"shapeIdList": [
		"blur_circle",
		"circle"
	],
	"startColor": {
		"hue": 205,
		"hueVariance": 0,
		"saturation": 35,
		"saturationVariance": 41,
		"luminance": 100,
		"luminanceVariance": "16"
	},
	"blendMode": true,
	"alphaCurveType": "1",
	"VERSION": "1.0.0"
}
	  );

	  createjs.Ticker.framerate = 60;
	  createjs.Ticker.timingMode = createjs.Ticker.RAF;
	  createjs.Ticker.addEventListener("tick", handleTick);
	});

	function handleTick() {
	  particleSystem.update();

	  stage.update();
	}